import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import '../../../sass/components/list/coliving.scss';
import '../../../sass/components/list/city_landing_modal.scss';
import Modal from '../../components/Modal/index';
import storageAvailable from '../../helpers/storage_available';
import { fetchData } from '../../helpers/base_data_fetcher';

function CityLandingModal({userType}) {
  const [showDialog, setShowDialog] = useState(true);

  const close = () => {
    setShowDialog(false);
  };

  return (
    <Modal
      close={close}
      showDialog={showDialog}
      id="get-city-landing-modal"
      modalLabelIcon="far fa-check-circle modal--city-landing-promo-icon"
      modalLabelText="Your ad is now live"
      wrapperClass="modal--city-landing-promo"
      initialFocus=".modal__close"
    >
      <p>
        <strong>Be proactive</strong>
      </p>
      {userType == 'seeker' ? (
        <p>
          Find rooms you love and get in touch to get the best rooms fast!          
        </p>
      ) : (
        <p>
          View matching flatmates and contact them <br />
          (we&apos;ll send them your ad at the same time)
        </p>
      )}
      <button className="button button--wide" type="button" onClick={close}>
        View matching ads
      </button>
    </Modal>
  );
}

export default function initialiseCityLandingModal() {
  const mountElement = document.getElementById('promoFromCityLanding');

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const showModal =
    urlParams.get('from_city_landing') || urlParams.get('landing_wanted_ad');

  const modalSeen = storageAvailable('sessionStorage')
    ? sessionStorage.getItem('city_landing_promo')
    : null;

  if (showModal && mountElement && !modalSeen) {
    fetchData('customer.initial_type').then((userType) => {
      ReactDOM.render(<CityLandingModal userType={userType} />, mountElement);
    })
    
    if (storageAvailable('sessionStorage')) {
      sessionStorage.setItem('city_landing_promo', '1');
    }
  }
}
